import { useCachedBasicData } from "@/utils/hooks/useCachedBasicData";
import { Select } from "antd";
import { AntSekelton } from "../Skeleton";
import { memo, useMemo } from "react";

const SelectCachedOptionsInput = ({ ...props }) => {
  const { optionKey, options: optionsFn, filter, allowClear = true, ...restProps } = props;
  const { cachedBasicData, basicDataResponse, contractsDataResponse, houseExaminationsDataResponse } =
    useCachedBasicData();

  const isLoading =
    basicDataResponse.isLoading || contractsDataResponse.isLoading || houseExaminationsDataResponse.isLoading;

  const list = cachedBasicData[optionKey];
  const filteredList = useMemo(() => {
    if (!Array.isArray(list)) return [];
    return list.filter((...args) => filter?.(...args) ?? true);
  }, [list, filter]);

  if (isLoading) {
    return <AntSekelton.Input />;
  }
  return (
    <Select
      {...restProps}
      allowClear={allowClear}
      value={restProps.value ?? undefined}
      optionFilterProp="q"
      className="w-full"
      style={{ minHeight: "50px", ...(restProps?.style ?? {}) }}
      options={filteredList.map((...args) => ({
        q: args[0]?.q,
        ...((typeof optionsFn === "function" && optionsFn?.(...args)) || {}),
      }))}
    />
  );
};

export const SelectCachedOptions = memo(SelectCachedOptionsInput);

const Display = ({ value, campareBy = "value", optionKey, filter, render = undefined, isLoading = false }) => {
  const {
    cachedBasicData,
    basicDataResponse: { isLoading: isBasicDataLoading },
    contractsDataResponse: { isLoading: isContractsLoading },
    houseExaminationsDataResponse: { isLoading: isHouseExaminationsLoading },
  } = useCachedBasicData();

  const loading = isLoading ? isLoading : isBasicDataLoading || isContractsLoading || isHouseExaminationsLoading;
  const cachedData = cachedBasicData[optionKey];

  const option = useMemo(() => {
    const pool = Array.isArray(cachedData) ? cachedData.filter((...args) => filter?.(...args) ?? true) : [];
    return pool.find((item) => String(item[campareBy]) === String(value));
  }, [cachedData, campareBy, filter, value]);

  if (loading) {
    return <AntSekelton.Text />;
  }

  if (!option) return <span>{value || "-"}</span>;

  return render ? render?.(option) || "-" : <span>{option || "-"}</span>;
};

SelectCachedOptions.Display = memo(Display);
